import React from "react";
import { createUseStyles } from "react-jss";
var useStyles = createUseStyles({
    svg: {
        fill: function (props) { return props.color; },
        width: 20,
        height: 26,
        flexShrink: 0,
        userSelect: "none",
    }
});
export default function TrashcanIcon(_a) {
    var color = _a.color;
    var classes = useStyles({ color: color });
    return (React.createElement("svg", { viewBox: "0 0 20.21 25.91", className: classes.svg },
        React.createElement("path", { d: "M19.25,2.26h-6.27v-1.4c0-0.32-0.26-0.58-0.58-0.58H7.7c-0.32,0-0.59,0.26-0.59,0.59v1.4H1\n                c-0.42,0-0.75,0.34-0.75,0.75v0.7c0,0.03,0.02,0.05,0.05,0.05H19.9c0.03,0,0.05-0.02,0.05-0.05V2.97\n                C19.95,2.58,19.64,2.26,19.25,2.26z M8.43,1.45c0-0.06,0.05-0.12,0.12-0.12h3.29c0.06,0,0.12,0.05,0.12,0.12v0.36\n                c0,0.06-0.05,0.12-0.12,0.12H8.55c-0.06,0-0.12-0.05-0.12-0.12V1.45z" }),
        React.createElement("path", { d: "M0.31,4.5v1.36c0,0.54,0.44,0.97,0.97,0.97h0.05v17.09c0,0.89,0.72,1.61,1.61,1.61h14.32\n                c0.89,0,1.61-0.72,1.61-1.61V6.83h0.04c0.54,0,0.97-0.44,0.97-0.97V4.5H0.31z M6.76,23.11H4.88V8.34h1.87V23.11z M10.98,23.11H9.1\n                V8.34h1.87V23.11z M15.42,23.11h-1.87V8.34h1.87V23.11z" })));
}
//# sourceMappingURL=TrashcanIcon.js.map